"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var slate_1 = require("slate");
var lab_1 = require("@material-ui/lab");
var NoteAddRounded_1 = __importDefault(require("@material-ui/icons/NoteAddRounded"));
var ClearRounded_1 = __importDefault(require("@material-ui/icons/ClearRounded"));
var core_2 = require("@21st-night/core");
var editor_web_1 = require("@21st-night/editor-web");
var CardEditorLayout_1 = __importDefault(require("../CardEditorLayout"));
var CardQuestionForm_1 = __importDefault(require("../CardQuestionForm"));
var CardAnswerForm_1 = __importDefault(require("../CardAnswerForm"));
var CardCategorySelectContainer_1 = __importDefault(require("../CardCategorySelectContainer"));
var CardSubcategorySelectContainer_1 = __importDefault(require("../CardSubcategorySelectContainer"));
var CardPreview_1 = __importDefault(require("../../Card/CardPreview"));
var Button_1 = __importDefault(require("../../Button"));
var PlainText_1 = __importDefault(require("../../PlainText"));
var LoadingIndicator_1 = __importDefault(require("../../LoadingIndicator"));
var RichTextEditor_1 = __importDefault(require("../../RichTextEditor"));
var DeckFilterInputContainer_1 = __importDefault(require("../../Deck/DeckFilterInputContainer"));
var CardFormContainer = function (_a) {
    var actionButtons = _a.actionButtons, disableNoteLinking = _a.disableNoteLinking, onSubmit = _a.onSubmit, secondaryAction = _a.secondaryAction;
    var deck = core_2.useDeck();
    var db = core_2.useFirebase().db;
    var uploads = core_2.useUploads().uploads;
    var _b = core_2.useCardForm(), setView = _b.setView, view = _b.view, answer = _b.answer, question = _b.question, explanation = _b.explanation, summary = _b.summary, category = _b.category, subcategories = _b.subcategories, note = _b.note, providedLinkedNote = _b.linkedNote, onFieldChange = _b.onFieldChange, setValue = _b.setValue, setErrors = _b.setErrors, errors = _b.errors;
    var _c = __read(react_1.useState(false), 2), noteSelectOpen = _c[0], setNoteSelectOpen = _c[1];
    var _d = __read(react_1.useState(null), 2), selectedNote = _d[0], setSelectedNote = _d[1];
    var _e = __read(react_1.useState(null), 2), selectedNoteSelection = _e[0], setSelectedNoteSelection = _e[1];
    var _f = __read(react_1.useState(false), 2), loadingSelectedNote = _f[0], setLoadingSelectedNote = _f[1];
    var _g = __read(react_1.useState(providedLinkedNote), 2), linkedNote = _g[0], setLinkedNote = _g[1];
    var _h = __read(react_1.useState(false), 2), clozeDeletionMode = _h[0], setClozeDeletionMode = _h[1];
    react_1.useEffect(function () {
        var descendants = slate_1.Node.descendants({ children: question });
        var clozes = Array.from(descendants)
            .filter(function (node) { return slate_1.Element.isElement(node[0]) && node[0].type === 'cloze-deletion'; })
            .map(function (entry) { return entry[0]; });
        setClozeDeletionMode(clozes.length > 0);
        if (clozes.length > 0) {
            setValue('answer', [
                {
                    type: 'paragraph',
                    children: [
                        {
                            text: clozes.reduce(function (text, node) {
                                return "" + text + (text.length ? ', ' : '') + slate_1.Node.string(node);
                            }, ''),
                        },
                    ],
                },
            ]);
        }
    }, [question]);
    react_1.useEffect(function () {
        if (note && !linkedNote) {
            var deckNote = deck.getNote(note) || null;
            if (deckNote) {
                setLinkedNote({
                    title: deckNote.title,
                    content: JSON.parse(deckNote.content),
                    selection: null,
                });
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    function handleChangeView(event, value) {
        setView(value);
    }
    function handleSubmit(event) {
        event.preventDefault();
        // Validate the form
        var hasError = false;
        var validationErrors = {};
        if (editor_web_1.isDocumentEmpty(question)) {
            hasError = true;
            validationErrors.question = 'Question is required';
        }
        if (editor_web_1.isDocumentEmpty(answer)) {
            hasError = true;
            validationErrors.answer = 'Answer is required';
        }
        if (!hasError) {
            onSubmit({
                question: question,
                answer: answer,
                explanation: explanation,
                summary: summary,
                category: category,
                subcategories: subcategories,
                note: note,
            }, linkedNote);
        }
        else {
            setErrors(validationErrors);
        }
    }
    var toggleNoteSelectOpen = react_1.useCallback(function () {
        setNoteSelectOpen(function (value) { return !value; });
        setSelectedNote(null);
        setSelectedNoteSelection(null);
    }, []);
    var fetchNote = react_1.useCallback(function (noteId) { return __awaiter(void 0, void 0, void 0, function () {
        var noteDoc, deckNote, noteData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoadingSelectedNote(true);
                    return [4 /*yield*/, db.collection('notes').doc(noteId).get()];
                case 1:
                    noteDoc = _a.sent();
                    deckNote = deck.getNote(noteId) || {};
                    if (noteDoc.exists) {
                        noteData = noteDoc.data();
                        setSelectedNote(__assign(__assign({ id: noteId }, deckNote), noteData));
                    }
                    setLoadingSelectedNote(false);
                    return [2 /*return*/];
            }
        });
    }); }, [db, deck]);
    var handleClickNoteItem = react_1.useCallback(function (noteId) {
        fetchNote(noteId);
    }, [fetchNote]);
    var handleLinkNote = react_1.useCallback(function () {
        if (selectedNote) {
            setValue('note', selectedNote.id);
            if (editor_web_1.isDocumentEmpty(question)) {
                var editor = slate_1.createEditor();
                var noteContent = JSON.parse(selectedNote.content);
                editor.children = noteContent;
                if (selectedNoteSelection) {
                    noteContent = slate_1.Node.fragment(editor, selectedNoteSelection);
                }
                setValue('question', noteContent);
            }
            if (!category && selectedNote.category) {
                setValue('category', selectedNote.category);
            }
            if (!subcategories.length &&
                selectedNote.subcategories &&
                selectedNote.subcategories.length) {
                setValue('subcategories', selectedNote.subcategories);
            }
            setLinkedNote({
                title: selectedNote.title,
                content: JSON.parse(selectedNote.content),
                selection: selectedNoteSelection,
            });
        }
        toggleNoteSelectOpen();
    }, [
        category,
        question,
        selectedNote,
        selectedNoteSelection,
        setValue,
        subcategories.length,
        toggleNoteSelectOpen,
    ]);
    var categorySelect = (react_1.default.createElement(CardCategorySelectContainer_1.default, { onChange: onFieldChange, value: category }));
    var subcategorySelect = (react_1.default.createElement(CardSubcategorySelectContainer_1.default, { onChange: onFieldChange, value: subcategories }));
    var noteSelect = disableNoteLinking ? ('') : (react_1.default.createElement(core_1.List, { style: { marginTop: 16, marginBottom: 32 } },
        (!note || !linkedNote) && (react_1.default.createElement(core_1.ListItem, { button: true, onClick: toggleNoteSelectOpen },
            react_1.default.createElement(core_1.ListItemIcon, { style: { minWidth: 36 } },
                react_1.default.createElement(NoteAddRounded_1.default, null)),
            react_1.default.createElement(core_1.ListItemText, null, "Attach a note"))),
        note && linkedNote && (react_1.default.createElement(core_1.ListItem, { button: true, onClick: toggleNoteSelectOpen, style: { left: -16, width: 'calc(100% + 16px)', paddingRight: 32 } },
            react_1.default.createElement(core_1.ListItemText, { primary: "Note", secondary: react_1.default.createElement("strong", { style: { color: '#2196F3' } }, linkedNote.title) }),
            react_1.default.createElement(core_1.ListItemSecondaryAction, { style: { right: 0 } },
                react_1.default.createElement(core_1.IconButton, { size: "small", color: "inherit", style: { color: '#BDBDBD' }, onClick: function () {
                        setValue('note', null);
                        setSelectedNote(null);
                    } },
                    react_1.default.createElement(ClearRounded_1.default, null)))))));
    return (react_1.default.createElement("form", { onSubmit: handleSubmit },
        react_1.default.createElement(CardEditorLayout_1.default, { secondaryAction: secondaryAction, view: view || 'question', disableTabs: uploads.length > 0, onChangeView: handleChangeView, answerError: !!errors.answer, questionError: !!errors.question },
            view === 'question' && (react_1.default.createElement(CardQuestionForm_1.default, { actionButtons: actionButtons, value: question, onChange: function (value) { return setValue('question', value); }, errors: errors, categorySelect: categorySelect, subcategorySelect: subcategorySelect, noteSelect: noteSelect })),
            view === 'answer' && (react_1.default.createElement(CardAnswerForm_1.default, { clozeDeletionMode: clozeDeletionMode, actionButtons: actionButtons, values: {
                    answer: answer,
                    explanation: explanation,
                    summary: summary,
                }, onChange: setValue, errors: errors, categorySelect: categorySelect, subcategorySelect: subcategorySelect, noteSelect: noteSelect })),
            view === 'preview' && (react_1.default.createElement(CardPreview_1.default, { card: {
                    question: question,
                    answer: answer,
                    explanation: explanation,
                    summary: summary,
                } }))),
        react_1.default.createElement(core_1.Dialog, { open: noteSelectOpen, maxWidth: "sm", fullWidth: true },
            react_1.default.createElement(core_1.DialogTitle, { style: { paddingBottom: 0 } }, "Attach a note"),
            react_1.default.createElement(core_1.DialogContent, null,
                !selectedNote && (react_1.default.createElement(react_1.Fragment, null,
                    react_1.default.createElement(DeckFilterInputContainer_1.default, { deck: deck }),
                    react_1.default.createElement(core_1.List, null, !selectedNote &&
                        deck.filteredNotes.map(function (noteItem) { return (react_1.default.createElement(core_1.ListItem, { button: true, key: noteItem.id, onClick: function () { return handleClickNoteItem(noteItem.id); } },
                            react_1.default.createElement(core_1.ListItemText, { primary: noteItem.title, secondary: react_1.default.createElement(PlainText_1.default, { maxLength: 160, document: JSON.parse(noteItem.content) }) }))); })))),
                loadingSelectedNote && (react_1.default.createElement("div", { style: {
                        position: 'absolute',
                        backgroundColor: 'rgba(0, 0, 0, 0.3)',
                        left: 0,
                        right: 0,
                        top: 0,
                        bottom: 0,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    } },
                    react_1.default.createElement(LoadingIndicator_1.default, { size: "large" }))),
                selectedNote && (react_1.default.createElement("div", null,
                    react_1.default.createElement(lab_1.Alert, { severity: "info", style: { marginBottom: 16 } }, "Select text to link to a specific part of the note."),
                    react_1.default.createElement(core_1.Typography, { gutterBottom: true, variant: "h3" }, selectedNote.title),
                    react_1.default.createElement(RichTextEditor_1.default, { selectionOnly: true, disableToolbar: true, disableHoveringToolbar: true, highlightCardLink: "all", initialValue: selectedNote.content, onSelectionChange: function (selection) {
                            return setSelectedNoteSelection(selection);
                        } })))),
            react_1.default.createElement(core_1.DialogActions, null,
                react_1.default.createElement(Button_1.default, { onClick: toggleNoteSelectOpen }, "Cancel"),
                selectedNote && (react_1.default.createElement(Button_1.default, { color: "primary", variant: "contained", onClick: handleLinkNote },
                    "Link ",
                    selectedNoteSelection ? 'selected portion' : 'note'))))));
};
exports.default = CardFormContainer;
//# sourceMappingURL=CardFormContainer.js.map